// web/src/tutorial-detail.ts
// /details/<slug>.html 的入口脚本。
// 只 import「软件界面详细说明」这一类正文：各类正文合起来近 2MB，
// 入口按类分包才能让本页只下载自己这一类的图文。
import { initTutorialPage } from "./tutorial/pages";
import { DETAIL_DOCS } from "./tutorial/detail/index";

initTutorialPage("detail", DETAIL_DOCS);
